module.exports = __webpack_public_path__ + "img/servicios2_2.b4b25185.png";